var _use, _use2, _use3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustration = function SvgIllustration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 607 393",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.936 -233.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.1 239.5c.2-3.6 3.4-6.3 7-6.1l481.8 31.7c3.7.2 6.4 3.3 6.1 6.9l-19.4 296.3c-.2 3.6-3.4 6.3-7 6.1l-481.8-31.6c-3.6-.3-6.4-3.4-6.1-7l19.4-296.3Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m431 260.1 83.9 5.5-.5 7.6-83.9-5.5.5-7.6Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4 264c.3-3.8 3.5-6.6 7.3-6.4l332.4 21.8c3.8.3 6.7 3.6 6.4 7.4l-2.3 34.7c-.2 3.8-3.5 6.7-7.3 6.4l-332.4-21.8c-3.7-.3-6.6-3.5-6.4-7.3l2.3-34.8Z",
    style: {
      fill: "#94a3b8",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.6 244.9c.1-.9.8-1.6 1.7-1.5l30.5 2c.9 0 1.5.8 1.5 1.7l-2 30.4c-.1.9-.9 1.6-1.8 1.5l-30.4-2c-.9 0-1.6-.8-1.5-1.7l2-30.4Z",
    style: {
      fill: "#94a3b8",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.4 242.7 30.4 2-.1 1.3-30.4-2 .1-1.3Zm32.6 4.5-2 30.4-1.4-.1 2-30.4 1.4.1Zm-4.5 32.6-30.4-2 .1-1.4 30.4 2-.1 1.4Zm-32.6-4.4 2-30.5 1.4.1-2 30.5-1.4-.1Zm2.2 2.4c-1.3-.1-2.3-1.2-2.2-2.4h1.4c0 .6.4 1 .9 1.1l-.1 1.3Zm32.9-.2c-.1 1.3-1.2 2.2-2.5 2.2l.1-1.4c.5 0 1-.4 1-.9l1.4.1Zm-.2-32.9c1.3.1 2.3 1.2 2.2 2.5l-1.4-.1c0-.5-.4-1-.9-1l.1-1.4Zm-30.5-.6c-.5-.1-1 .3-1 .8l-1.4-.1c.1-1.2 1.2-2.2 2.5-2.1l-.1 1.4Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.1 282.4 113.1 7.5-.6 9.2-113.1-7.4.6-9.3Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.5 283.7-.6 8-1.4-.1-3.2-5.3-.4 5-1.6-.1.5-8 1.5.1 3.1 5.3h.1l.3-5 1.7.1Zm3.5 8.3c-.6 0-1.1-.167-1.5-.5a3.203 3.203 0 0 1-1-1.1c-.2-.467-.267-1.033-.2-1.7 0-.6.167-1.133.5-1.6.267-.4.6-.733 1-1 .467-.2 1-.3 1.6-.3.667.067 1.2.233 1.6.5.4.333.7.733.9 1.2.267.467.367 1 .3 1.6-.067.667-.233 1.2-.5 1.6a2.905 2.905 0 0 1-1.1 1.1c-.467.2-1 .267-1.6.2Zm.1-1.3c.267.067.5.033.7-.1.2-.2.367-.433.5-.7.133-.267.2-.567.2-.9 0-.333-.033-.633-.1-.9-.067-.333-.2-.567-.4-.7-.133-.2-.333-.3-.6-.3-.333 0-.6.067-.8.2a2.315 2.315 0 0 0-.4.6c-.133.267-.2.567-.2.9-.067.4-.033.733.1 1 .067.267.167.5.3.7.2.133.433.2.7.2Zm4 1.5.4-6 1.6.1-.1 1h.1c.133-.333.333-.567.6-.7.333-.2.7-.3 1.1-.3.4.067.733.2 1 .4s.467.5.6.9c.133-.333.367-.6.7-.8.333-.2.733-.267 1.2-.2.533 0 .967.2 1.3.6.333.333.5.833.5 1.5l-.3 4.1-1.7-.2.3-3.7c0-.333-.067-.567-.2-.7-.2-.2-.433-.3-.7-.3a.694.694 0 0 0-.7.2c-.2.2-.3.467-.3.8l-.3 3.6-1.6-.1.3-3.7c0-.333-.067-.567-.2-.7-.2-.2-.433-.333-.7-.4a.68.68 0 0 0-.5.2 1.583 1.583 0 0 0-.4.3c-.067.2-.1.4-.1.6l-.3 3.6-1.6-.1Zm12.8.9c-.6 0-1.133-.133-1.6-.4-.4-.333-.7-.733-.9-1.2-.2-.467-.3-1-.3-1.6.067-.667.233-1.2.5-1.6a2.905 2.905 0 0 1 1.1-1.1c.467-.2.967-.3 1.5-.3.4.067.767.167 1.1.3.333.133.633.333.9.6.267.267.433.6.5 1 .133.4.2.867.2 1.4l-.1.4-4.1-.2c0 .267.067.533.2.8.067.2.2.367.4.5s.433.2.7.2h.5c.2-.067.333-.133.4-.2.133-.133.233-.267.3-.4l1.5.2a1.745 1.745 0 0 1-.5.9c-.267.267-.6.467-1 .6-.4.133-.833.167-1.3.1Zm-1.2-2.7.1-1 2.4.1c.067-.2.033-.4-.1-.6a.964.964 0 0 0-.4-.5 3.083 3.083 0 0 0-.6-.2c-.267 0-.5.067-.7.2-.2.067-.367.2-.5.4a3.86 3.86 0 0 0-.2.5h-.9v1l.9.1Zm.1-1h-.1v-.1h.1v.1Zm9.6 4.3a2.428 2.428 0 0 1-1.2-.5c-.333-.267-.6-.633-.8-1.1-.2-.467-.267-1.033-.2-1.7 0-.667.133-1.233.4-1.7.267-.4.6-.733 1-1 .333-.2.733-.267 1.2-.2.333 0 .6.067.8.2.267.133.433.3.5.5.133.133.233.3.3.5h.1l.2-3 1.6.1-.5 8-1.6-.1v-1a3.26 3.26 0 0 1-.4.5 2.315 2.315 0 0 1-.6.4c-.2.067-.467.1-.8.1Zm.6-1.3c.267 0 .5-.067.7-.2.2-.133.367-.333.5-.6.133-.267.2-.567.2-.9 0-.4-.033-.733-.1-1s-.2-.467-.4-.6a2.234 2.234 0 0 0-.7-.3c-.267 0-.5.067-.7.2-.2.133-.333.333-.4.6-.133.267-.2.567-.2.9-.067.333-.033.667.1 1 .067.267.167.467.3.6.2.133.433.233.7.3Zm6.9 1.8a4.102 4.102 0 0 1-1.6-.5c-.4-.333-.7-.733-.9-1.2-.2-.467-.3-1-.3-1.6.067-.6.233-1.133.5-1.6a2.28 2.28 0 0 1 1.1-1c.467-.267 1-.367 1.6-.3.6 0 1.1.167 1.5.5.467.267.8.633 1 1.1.2.467.267 1.033.2 1.7 0 .6-.133 1.133-.4 1.6-.267.4-.633.733-1.1 1-.467.2-1 .3-1.6.3Zm.1-1.3c.267 0 .5-.067.7-.2.2-.133.333-.333.4-.6.133-.267.233-.567.3-.9 0-.4-.033-.733-.1-1s-.2-.5-.4-.7a2.234 2.234 0 0 0-.7-.3c-.267 0-.5.067-.7.2-.2.2-.367.433-.5.7-.067.267-.133.567-.2.9 0 .333.033.633.1.9s.2.5.4.7c.2.2.433.3.7.3Zm6.5 1.6.4-6 1.6.1-.1 1h.1c.133-.333.333-.6.6-.8.267-.133.567-.2.9-.2h.3c.067.067.133.1.2.1l-.1 1.5c-.067-.067-.167-.1-.3-.1a.883.883 0 0 1-.4-.1c-.2 0-.4.067-.6.2-.2.067-.367.2-.5.4-.133.133-.2.333-.2.6l-.3 3.4-1.6-.1Zm7 .6a4.102 4.102 0 0 1-1.6-.5c-.4-.267-.7-.633-.9-1.1a4.8 4.8 0 0 1-.3-1.7c.067-.6.233-1.133.5-1.6a2.28 2.28 0 0 1 1.1-1c.4-.267.9-.367 1.5-.3.4 0 .767.067 1.1.2.333.2.633.433.9.7.2.267.367.6.5 1 .133.333.167.767.1 1.3v.5l-4.1-.3c0 .267.033.533.1.8.133.2.3.367.5.5s.433.2.7.2h.5l.4-.2c.133-.133.233-.267.3-.4l1.5.2c-.067.4-.233.7-.5.9-.267.267-.6.467-1 .6-.4.133-.833.2-1.3.2Zm-1.2-2.8.1-1 2.4.2c.067-.267.033-.5-.1-.7a.602.602 0 0 0-.4-.4c-.133-.133-.333-.2-.6-.2-.267-.067-.5-.033-.7.1-.2.067-.367.2-.5.4l-.2.6-.9-.1v1l.9.1Zm10.2-1H239c0-.133-.067-.267-.2-.4a1.175 1.175 0 0 0-.3-.2 3.86 3.86 0 0 0-.5-.2c-.267 0-.467.067-.6.2-.2.067-.3.2-.3.4 0 .133.033.233.1.3.133.133.333.233.6.3l1.1.3c.533.2.933.433 1.2.7.267.267.4.633.4 1.1 0 .333-.133.667-.4 1-.267.267-.6.467-1 .6-.4.133-.867.2-1.4.2-.8-.067-1.433-.3-1.9-.7-.4-.333-.633-.8-.7-1.4h1.6c.067.267.2.467.4.6.133.133.367.233.7.3.267 0 .5-.067.7-.2.2-.067.3-.2.3-.4 0-.133-.067-.267-.2-.4a3.86 3.86 0 0 0-.5-.2l-1.1-.3c-.533-.133-.933-.367-1.2-.7-.267-.333-.4-.7-.4-1.1 0-.4.133-.733.4-1 .2-.267.5-.467.9-.6.4-.133.867-.167 1.4-.1.733 0 1.3.2 1.7.6.467.333.7.767.7 1.3Zm4.5-1.4-.1 1.2h-1.1l-.2 2.9v.3c.067.133.133.2.2.2.133.067.233.1.3.1h.4l.2 1.2c-.067.067-.167.1-.3.1h-.6c-.4 0-.733-.067-1-.2-.333-.133-.567-.333-.7-.6-.133-.267-.2-.6-.2-1l.2-3.1-.8-.1.1-1.2h.8l.1-1.4 1.7.1-.1 1.4 1.1.1Zm2.4 6.3c-.4 0-.733-.1-1-.3-.333-.133-.567-.333-.7-.6-.133-.267-.2-.6-.2-1 0-.333.067-.6.2-.8a.894.894 0 0 1 .6-.5c.2-.133.433-.233.7-.3.267-.067.567-.1.9-.1.333 0 .6-.033.8-.1.2 0 .367-.033.5-.1.067-.067.133-.167.2-.3 0-.2-.067-.4-.2-.6-.2-.133-.433-.2-.7-.2-.267 0-.5.033-.7.1-.2.133-.333.3-.4.5l-1.5-.2c.067-.4.233-.7.5-.9a2.66 2.66 0 0 1 .9-.6c.4-.133.833-.167 1.3-.1.333 0 .667.067 1 .2.267.067.5.2.7.4.267.133.467.333.6.6.133.267.167.6.1 1l-.3 4-1.5-.1v-.8a3.26 3.26 0 0 1-.4.5l-.6.2c-.267.067-.533.1-.8.1Zm.5-1.1c.267 0 .5-.033.7-.1.2-.067.333-.2.4-.4a.68.68 0 0 0 .2-.5l.1-.7c-.067.067-.133.1-.2.1-.133 0-.233.033-.3.1h-.7c-.2 0-.367.033-.5.1a1.583 1.583 0 0 0-.4.3c-.067.067-.1.167-.1.3 0 .267.067.467.2.6.133.133.333.2.6.2Zm8.2-1 .2-3.4 1.6.1-.3 6-1.6-.1v-1.1c-.2.333-.467.6-.8.8-.333.2-.7.267-1.1.2-.4 0-.767-.1-1.1-.3a1.817 1.817 0 0 1-.6-.8c-.2-.4-.267-.833-.2-1.3l.2-3.8 1.7.1-.2 3.5c-.067.4 0 .7.2.9.2.2.433.333.7.4.2 0 .4-.033.6-.1.2-.133.367-.267.5-.4.067-.2.133-.433.2-.7Zm2.8 2.8.4-6 1.6.1-.1 1h.1c.133-.333.333-.6.6-.8.267-.2.567-.267.9-.2h.3c.067 0 .133.033.2.1l-.1 1.4h-.3a.883.883 0 0 0-.4-.1c-.2 0-.4.033-.6.1a3.26 3.26 0 0 0-.5.4c-.133.2-.2.433-.2.7l-.3 3.4-1.6-.1Zm6.1.5a3.58 3.58 0 0 1-1-.3c-.333-.133-.567-.333-.7-.6a2.682 2.682 0 0 1-.2-1c0-.333.067-.633.2-.9.133-.2.333-.367.6-.5.2-.133.433-.233.7-.3h.9c.333-.067.6-.1.8-.1.267 0 .433-.033.5-.1.133-.067.2-.167.2-.3 0-.267-.067-.467-.2-.6-.133-.133-.367-.2-.7-.2-.267-.067-.5-.033-.7.1-.2.133-.333.3-.4.5l-1.5-.3c.067-.333.233-.633.5-.9.267-.2.567-.367.9-.5.4-.133.833-.2 1.3-.2l1 .2.8.4c.2.2.367.433.5.7.133.267.167.567.1.9l-.2 4.1-1.6-.1v-.9a3.26 3.26 0 0 1-.4.5c-.2.133-.4.233-.6.3-.267.067-.533.1-.8.1Zm.5-1.1c.267 0 .5-.033.7-.1.2-.133.367-.267.5-.4l.2-.6v-.6c-.067 0-.133.033-.2.1h-.3a.883.883 0 0 0-.4.1h-.3c-.2 0-.367.033-.5.1l-.4.2a.883.883 0 0 0-.1.4c0 .2.067.367.2.5s.333.233.6.3Zm6-2.1-.2 3.5-1.6-.1.3-6 1.6.1v1c.2-.333.467-.567.8-.7.267-.2.633-.3 1.1-.3.4.067.767.2 1.1.4.267.2.5.467.7.8.133.333.167.733.1 1.2l-.2 3.8-1.7-.1.3-3.5c0-.4-.1-.7-.3-.9-.133-.2-.367-.3-.7-.3-.267-.067-.467-.033-.6.1-.2.067-.367.2-.5.4a3.083 3.083 0 0 0-.2.6Zm8.6-2-.1 1.3-1.1-.1-.2 2.9v.4l.2.2h.7l.2 1.3h-.4c-.133.067-.3.1-.5.1a5.34 5.34 0 0 1-1.1-.3 1.302 1.302 0 0 1-.6-.6c-.133-.267-.2-.6-.2-1l.2-3.1-.8-.1.1-1.2h.8l.1-1.4 1.6.1v1.5h1.1Zm3.3 6.3c-.6 0-1.133-.167-1.6-.5-.4-.267-.7-.633-.9-1.1-.2-.467-.3-1.033-.3-1.7.067-.6.233-1.133.5-1.6.267-.4.633-.733 1.1-1 .467-.2.967-.3 1.5-.3.4.067.767.167 1.1.3.333.133.633.333.9.6.267.267.433.6.5 1 .133.4.2.833.2 1.3l-.1.5-4.1-.3c0 .333.067.6.2.8.067.267.2.467.4.6.2.067.433.133.7.2.2 0 .367-.033.5-.1.2 0 .333-.067.4-.2a.66.66 0 0 0 .3-.3l1.5.2a1.745 1.745 0 0 1-.5.9c-.267.267-.6.467-1 .6-.4.133-.833.167-1.3.1Zm-1.2-2.8.1-.9v-.1l-1-.1v1.1h.9Zm2.6-.9c0-.267-.067-.467-.2-.6a.964.964 0 0 0-.4-.5c-.133-.133-.333-.2-.6-.2-.267 0-.5.033-.7.1-.2.133-.367.3-.5.5a3.86 3.86 0 0 0-.2.5l2.6.2Zm-54.5-3.5h.1-.1Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.3 295.1 79.4 5.3-.5 6.8-79.4-5.2.5-6.9Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 316.5c.1-1.5 1.5-2.7 3-2.6l2.7.2c1.5.1 2.7 1.4 2.6 2.9l-.2 2.8c-.1 1.5-1.4 2.6-2.9 2.5l-2.8-.1c-1.5-.1-2.6-1.5-2.5-3l.1-2.7Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.1 316.1c.2.067.367.133.5.2.133 0 .233.067.3.2.133.133.2.267.2.4.067.133.1.3.1.5s0 .3-.1.9v.8a3.86 3.86 0 0 1-.2.5c0 .133-.067.233-.2.3a1.583 1.583 0 0 1-.4.3h-1.4c-.5-.1-.6-.1-.8-.1-.2 0-.367-.033-.5-.1a.66.66 0 0 1-.3-.3 1.583 1.583 0 0 1-.3-.4V318c.1-.6.1-.6.1-.9 0-.2.033-.367.1-.5a.66.66 0 0 1 .3-.3c.133-.133.267-.2.4-.2.067-.067.233-.1.5-.1.2 0 .3 0 .8.1h.9Zm-.9.3H480a1.175 1.175 0 0 0-.3.2c-.067.067-.1.133-.1.2-.067.067-.1.2-.1.4-.1.2-.1.3-.1.8 0 .6 0 .6-.1.8 0 .2.1.4.1.4 0 .133.033.233.1.3.067.067.167.1.3.1 0 .1.1.1.3.1.3.1.3.1.9.1.5 0 .6 0 .8.1.2 0 .3-.1.4-.1.067 0 .133-.033.2-.1s.133-.167.2-.3c.067-.067.1-.167.1-.3 0-.3 0-.3.1-.9V317l-.4-.4c-.067-.067-.2-.1-.4-.1s-.3 0-.8-.1Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.1 318.2c0 .6-.5 1-1.1 1-.6-.1-1-.6-1-1.1.1-.6.6-1.1 1.2-1 .5 0 1 .5.9 1.1Zm-.3 0c0-.4-.3-.7-.7-.8-.4 0-.7.3-.7.7 0 .4.3.7.6.7.4 0 .7-.3.8-.6Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.5 317.1c0 .1-.1.2-.3.2-.1 0-.2-.1-.2-.2 0-.2.1-.3.3-.3.1.1.2.2.2.3ZM488 317.2c.1-1.5 1.5-2.7 3-2.6l2.7.2c1.5.1 2.7 1.4 2.6 2.9l-.2 2.8c-.1 1.5-1.4 2.7-2.9 2.6l-2.8-.2c-1.5-.1-2.6-1.4-2.5-3l.1-2.7Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.8 318.1v.1c-.1 1.1-1 2.3-2.6 2.2-.467 0-.9-.133-1.3-.4h.2c.4 0 .767-.1 1.1-.3-.4 0-.7-.3-.7-.6h.3c-.3-.1-.6-.5-.6-.9.133.067.267.1.4.1-.2-.2-.4-.4-.3-.7 0-.2.033-.333.1-.4.4.5 1 .9 1.7 1v-.2c0-.5.4-.9.9-.8.267 0 .467.1.6.3.2-.067.367-.133.5-.2-.067.2-.2.367-.4.5.2-.067.367-.1.5-.1l-.4.4Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 317.9c.1-1.5 1.5-2.7 3-2.6l2.7.2c1.5.1 2.7 1.4 2.6 3l-.2 2.7c-.1 1.5-1.4 2.7-2.9 2.6l-2.8-.2c-1.5-.1-2.6-1.4-2.5-2.9l.1-2.8Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.1 318.3c-.1 0-.3-.1-.4-.1-.3 0-.3.1-.3.3v.4h.6l-.1.7-.6-.1-.1 2.1h-.9l.2-2.1h-.5l.1-.7h.4l.1-.4c0-.6.3-.9 1-.9.2 0 .4.1.6.1l-.1.7Z",
    style: {
      fill: "#f6f8fc",
      fillOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.1 313.9 224.5 14.7-.9 13.8-224.5-14.8.9-13.7ZM479.7 334.6l30.5 2-.9 13.8-30.5-2.1.9-13.7Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m162.3 341.4 84.9 5.5-.7 10.4-84.9-5.6.7-10.3Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.1 359.9c.1-1.5 1.4-2.6 2.9-2.5l78 5.1c1.5.1 2.6 1.4 2.5 2.9l-6.3 96.3c-.1 1.5-1.4 2.6-2.9 2.5l-77.9-5.1c-1.6-.1-2.7-1.4-2.6-2.9l6.3-96.3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 364.3c.1-1.5 1.4-2.6 2.9-2.5l69.7 4.5c1.5.1 2.6 1.4 2.5 3l-3.1 47.4c-.1 1.5-1.4 2.7-2.9 2.6l-69.7-4.6c-1.5-.1-2.7-1.4-2.6-2.9l3.2-47.5Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.4 418.6 19.6 1.3-.6 8.3-19.5-1.3.5-8.3ZM160.8 428.3l75.2 4.9-.4 6.9-75.3-5 .5-6.8ZM159.5 448.2l19.2 1.3-.4 6.8-19.3-1.2.5-6.9ZM227.8 452.7l6.8.4-.4 6.9-6.9-.4.5-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.7 365.7c.1-1.5 1.4-2.7 2.9-2.6l77.9 5.1c1.6.1 2.7 1.4 2.6 3l-6.3 96.2c-.1 1.5-1.4 2.7-2.9 2.6l-78-5.1c-1.5-.1-2.7-1.5-2.6-3l6.4-96.2Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 370.1c.1-1.5 1.4-2.7 3-2.6l69.6 4.6c1.6.1 2.7 1.4 2.6 2.9l-3.1 47.4c-.1 1.6-1.4 2.7-2.9 2.6l-69.7-4.6c-1.5-.1-2.7-1.4-2.6-2.9l3.1-47.4Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249 424.4 19.5 1.3-.5 8.2-19.6-1.3.6-8.2ZM248.3 434l75.3 5-.5 6.8-75.2-4.9.4-6.9ZM247 453.9l19.3 1.3-.5 6.9-19.2-1.3.4-6.9ZM315.3 458.4l6.9.5-.5 6.9-6.8-.5.4-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.2 371.4c.1-1.5 1.4-2.6 3-2.5l77.9 5.1c1.5.1 2.7 1.4 2.6 2.9l-6.4 96.2c-.1 1.6-1.4 2.7-2.9 2.6l-77.9-5.1c-1.5-.1-2.7-1.4-2.6-2.9l6.3-96.3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.1 375.8c.1-1.5 1.4-2.6 2.9-2.5l69.7 4.5c1.5.1 2.7 1.4 2.6 3l-3.2 47.4c0 1.5-1.4 2.7-2.9 2.6l-69.7-4.6c-1.5-.1-2.6-1.4-2.5-2.9l3.1-47.5Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.5 430.1 19.6 1.3-.5 8.3-19.6-1.3.5-8.3ZM335.9 439.8l75.3 4.9-.5 6.9-75.3-5 .5-6.8ZM334.6 459.7l19.2 1.3-.4 6.8-19.3-1.2.5-6.9ZM402.9 464.2l6.9.4-.5 6.9-6.9-.4.5-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.8 377.2c.1-1.5 1.4-2.7 2.9-2.6l77.9 5.1c1.6.1 2.7 1.4 2.6 3l-6.3 96.2c-.1 1.5-1.4 2.7-2.9 2.6l-78-5.2c-1.5-.1-2.6-1.4-2.5-2.9l6.3-96.2Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.6 381.6c.1-1.5 1.4-2.7 3-2.6l69.7 4.6c1.5.1 2.6 1.4 2.5 2.9l-3.1 47.4c-.1 1.6-1.4 2.7-2.9 2.6l-69.7-4.6c-1.5-.1-2.7-1.4-2.6-2.9l3.1-47.4Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.1 435.9 19.6 1.3-.6 8.2-19.6-1.3.6-8.2ZM423.4 445.5l75.3 4.9-.4 6.9-75.3-4.9.4-6.9ZM422.1 465.4l19.3 1.3-.5 6.9-19.2-1.3.4-6.9ZM490.4 469.9l6.9.5-.4 6.9-6.9-.5.4-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m153.7 472.7 84.9 5.5-.7 10.4L153 483l.7-10.3Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.5 491.2c.1-1.5 1.4-2.6 2.9-2.5l107.1 7c1.6.1 2.7 1.4 2.6 2.9l-3.5 53.6c-.1 1.6-1.4 2.7-2.9 2.6l-107.2-7c-1.5-.1-2.6-1.4-2.5-3l3.5-53.6Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.5 492.9 19.6 1.3-.5 8.2-19.6-1.3.5-8.2ZM155.9 502.5l52.8 3.5-.4 6.8-52.9-3.4.5-6.9ZM153.6 536.9l19.3 1.2-.5 6.9-19.2-1.3.4-6.8Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3 499.4c.1-1.6 1.4-2.7 2.9-2.6l41.9 2.7c1.6.1 2.7 1.5 2.6 3l-3 45.3c-.1 1.6-1.4 2.7-2.9 2.6l-41.9-2.7c-1.5-.1-2.7-1.4-2.6-3l3-45.3Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.2 498.9c.1-1.5 1.4-2.7 3-2.6l107.1 7.1c1.5.1 2.7 1.4 2.6 2.9l-3.6 53.6c-.1 1.5-1.4 2.7-2.9 2.6l-107.1-7.1c-1.5-.1-2.7-1.4-2.6-2.9l3.5-53.6Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.3 500.5 19.6 1.3-.6 8.3-19.6-1.3.6-8.3ZM272.6 510.2l52.9 3.4-.5 6.9-52.8-3.5.4-6.8ZM270.4 544.5l19.2 1.3-.4 6.9-19.3-1.3.5-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 507c.1-1.5 1.4-2.6 3-2.5l41.9 2.7c1.5.1 2.7 1.4 2.6 2.9l-3 45.4c-.1 1.5-1.4 2.7-2.9 2.6l-42-2.8c-1.5-.1-2.7-1.4-2.5-2.9L330 507Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386 506.6c.1-1.6 1.4-2.7 2.9-2.6l107.1 7c1.5.1 2.7 1.4 2.6 3l-3.5 53.6c-.1 1.5-1.4 2.6-3 2.5l-107.1-7c-1.5-.1-2.6-1.4-2.5-2.9l3.5-53.6Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 508.2 19.6 1.3-.5 8.2-19.6-1.2.5-8.3ZM389.4 517.8l52.8 3.5-.5 6.9-52.8-3.5.5-6.9ZM387.1 552.2l19.3 1.3-.5 6.8-19.2-1.2.4-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.8 514.7c.1-1.5 1.4-2.7 2.9-2.6l41.9 2.8c1.6.1 2.7 1.4 2.6 2.9l-3 45.4c-.1 1.5-1.4 2.6-2.9 2.5l-41.9-2.7c-1.6-.1-2.7-1.4-2.6-2.9l3-45.4Z",
    style: {
      fill: "#cbd4e1",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.7 267.6c.1-2.3 2.1-4 4.4-3.8l119.9 7.8c2.3.2 4 2.2 3.9 4.4L631 563.4c-.1 2.3-2.1 4-4.4 3.8l-119.9-7.8c-2.3-.2-4-2.2-3.9-4.4l18.9-287.4Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.1 274.3c.2-1.9 1.8-3.4 3.7-3.2l107.6 7c1.9.1 3.3 1.8 3.2 3.7l-.5 6.9c-.1 1.9-1.7 3.3-3.6 3.2l-107.6-7.1c-1.9-.1-3.3-1.8-3.2-3.7l.4-6.8ZM526.7 296.9l52.2 3.5-.5 8.2-52.3-3.4.6-8.3ZM525.6 312.8c.1-1.9 1.8-3.4 3.7-3.3l27.5 1.9c1.9.1 3.3 1.7 3.2 3.6l-.4 6.2c-.1 1.9-1.8 3.3-3.7 3.2l-27.5-1.8c-1.9-.1-3.3-1.8-3.2-3.7l.4-6.1Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.3 309.2 27.5 1.8v.7l-27.5-1.8v-.7Zm31 5.8-.4 6.2h-.7l.4-6.2h.7Zm-4.4 9.7-27.5-1.8v-.7l27.5 1.8v.7Zm-31-5.8.4-6.2h.7l-.4 6.2h-.7Zm3.5 4.1c-2.1-.2-3.7-2-3.5-4.1l.7.1c-.2 1.7 1.1 3.2 2.8 3.3v.7Zm31.6-1.8c-.2 2.1-2 3.7-4.1 3.6l.1-.7c1.7.1 3.2-1.2 3.3-2.9h.7Zm-3.1-10.2c2 .1 3.6 1.9 3.5 4h-.7c.1-1.7-1.2-3.2-2.9-3.3l.1-.7Zm-27.5-1.2c-1.7-.1-3.2 1.2-3.3 2.9h-.7c.1-2.1 1.9-3.7 4-3.5v.6ZM564.1 315.3c.1-1.9 1.8-3.4 3.7-3.2l35.4 2.3c1.9.1 3.3 1.8 3.2 3.7l-.4 5.5c-.1 1.9-1.7 3.3-3.6 3.2l-35.4-2.4c-1.9-.1-3.4-1.7-3.3-3.6l.4-5.5Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.8 311.7 35.4 2.4v.6l-35.4-2.3v-.7Zm38.9 6.4-.4 5.5-.7-.1.4-5.5.7.1Zm-4.4 9.1-35.4-2.4v-.7l35.5 2.4-.1.7Zm-39-6.4.4-5.5.7.1-.4 5.5-.7-.1Zm3.5 4c-2.1-.1-3.6-1.9-3.5-4h.7c-.1 1.7 1.2 3.2 2.9 3.3l-.1.7Zm39.4-1.2c-.1 2.1-1.9 3.7-4 3.5v-.7c1.7.2 3.2-1.1 3.3-2.8h.7Zm-3.1-9.6c2 .2 3.6 2 3.5 4.1l-.7-.1c.1-1.7-1.2-3.2-2.9-3.3l.1-.7Zm-35.4-1.6c-1.7-.1-3.2 1.2-3.3 2.9l-.7-.1c.1-2.1 1.9-3.7 4-3.5v.7ZM524.6 328.6c.1-1.9 1.7-3.4 3.6-3.2l27.5 1.8c1.9.1 3.4 1.7 3.2 3.6l-.4 6.2c-.1 1.9-1.7 3.3-3.6 3.2l-27.5-1.8c-1.9-.1-3.4-1.7-3.2-3.6l.4-6.2Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.3 325 27.5 1.8-.1.7-27.5-1.8.1-.7Zm31 5.8-.4 6.2h-.6l.4-6.2h.6Zm-4.5 9.7-27.5-1.8.1-.7 27.5 1.8-.1.7Zm-31.1-5.8.4-6.2h.7l-.4 6.2h-.7Zm3.6 4.1c-2.1-.2-3.7-2-3.6-4.1l.7.1c-.1 1.7 1.2 3.2 2.9 3.3v.7Zm31.5-1.8c-.1 2.1-1.9 3.7-4 3.6v-.7c1.8.1 3.2-1.2 3.3-2.9h.7Zm-3.1-10.2c2.1.1 3.7 1.9 3.6 4h-.7c.1-1.7-1.2-3.2-2.9-3.3v-.7Zm-27.6-1.1c-1.7-.2-3.2 1.1-3.3 2.8h-.7c.2-2.1 2-3.7 4.1-3.5l-.1.7ZM563.1 331.1c.1-1.9 1.7-3.3 3.6-3.2l21.7 1.4c1.9.1 3.3 1.8 3.2 3.7l-.4 6.2c-.1 1.9-1.8 3.3-3.7 3.2l-21.6-1.5c-1.9-.1-3.4-1.7-3.2-3.6l.4-6.2Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.8 327.5 21.6 1.5v.7l-21.7-1.5.1-.7ZM592 333l-.4 6.2-.7-.1.4-6.2.7.1Zm-4.4 9.8-21.7-1.5.1-.7 21.6 1.5v.7Zm-25.2-5.5.4-6.2.7.1-.4 6.2-.7-.1Zm3.6 4c-2.1-.1-3.7-2-3.6-4h.7c-.1 1.7 1.2 3.2 2.9 3.3v.7Zm25.7-2.1c-.2 2.1-2 3.7-4 3.5v-.7c1.7.1 3.2-1.1 3.3-2.9l.7.1Zm-3.1-10.2c2.1.2 3.6 2 3.5 4.1l-.7-.1c.1-1.7-1.2-3.2-2.9-3.3l.1-.7Zm-21.7-.7c-1.7-.1-3.2 1.2-3.3 2.9l-.7-.1c.2-2.1 2-3.6 4.1-3.5l-.1.7ZM523.5 344.4c.2-1.9 1.8-3.4 3.7-3.2l27.5 1.8c1.9.1 3.3 1.7 3.2 3.6l-.4 6.2c-.1 1.9-1.8 3.4-3.7 3.2l-27.5-1.8c-1.9-.1-3.3-1.7-3.2-3.6l.4-6.2Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.2 340.8 27.5 1.8v.7l-27.5-1.8v-.7Zm31 5.8-.4 6.2h-.7l.4-6.2h.7Zm-4.4 9.7-27.5-1.8v-.7l27.5 1.8v.7Zm-31-5.8.4-6.2.7.1-.4 6.1h-.7Zm3.5 4.1c-2.1-.2-3.6-2-3.5-4.1l.7.1c-.1 1.7 1.2 3.2 2.9 3.3l-.1.7Zm31.5-1.7c-.1 2-1.9 3.6-4 3.5v-.7c1.7.1 3.2-1.2 3.3-2.9l.7.1Zm-3.1-10.2c2.1.1 3.6 1.9 3.5 4h-.7c.1-1.7-1.2-3.2-2.9-3.3l.1-.7Zm-27.5-1.1c-1.7-.1-3.2 1.1-3.3 2.9l-.7-.1c.1-2.1 1.9-3.7 4-3.5v.7ZM564.8 347.1c.1-1.9 1.7-3.3 3.6-3.2l40.3 2.6c1.9.1 3.3 1.8 3.2 3.7l-.4 5.5c-.1 1.9-1.8 3.3-3.7 3.2l-40.2-2.7c-1.9-.1-3.3-1.7-3.2-3.6l.4-5.5Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.5 343.5 40.2 2.7-.1.7-40.2-2.7.1-.7Zm43.8 6.7-.4 5.5-.7-.1.4-5.5.7.1Zm-4.4 9.1-40.2-2.7v-.7l40.2 2.7v.7Zm-43.7-6.7.4-5.5.6.1-.3 5.5-.7-.1Zm3.5 4c-2.1-.1-3.7-1.9-3.5-4h.7c-.1 1.7 1.1 3.2 2.9 3.3l-.1.7Zm44.2-.9c-.1 2.1-1.9 3.7-4 3.5v-.6c1.7.1 3.2-1.2 3.3-2.9h.7Zm-3.2-9.6c2.1.2 3.7 2 3.6 4.1l-.7-.1c.1-1.7-1.2-3.2-2.9-3.3v-.7Zm-40.3-1.9c-1.7-.1-3.1 1.2-3.3 2.9l-.6-.1c.1-2.1 1.9-3.6 4-3.5l-.1.7ZM522.2 365l48.8 3.2-.5 8.3-48.9-3.2.6-8.3Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 471.275,
    y: 144.318,
    width: 5.983,
    height: 5.983,
    transform: "matrix(.99723 0 0 .99723 50.936 233.39)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m529.6 377.9 19.6 1.3-.3 5.5-19.6-1.3.3-5.5Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 470.673,
    y: 153.944,
    width: 5.983,
    height: 5.983,
    transform: "matrix(.99723 0 0 .99723 50.936 233.39)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m529 387.5 26.1 1.8-.3 5.5-26.2-1.8.4-5.5Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 470.072,
    y: 163.671,
    width: 5.983,
    height: 5.983,
    transform: "matrix(.99723 0 0 .99723 50.936 233.39)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m528.4 397.2 28.1 1.8-.3 5.5-28.2-1.8.4-5.5ZM519 413.1l45.1 3-.6 8.2-45-2.9.5-8.3ZM518 428.9c.1-1.9 1.8-3.3 3.7-3.2l27.4 1.8c1.9.1 3.4 1.8 3.3 3.7l-.4 6.2c-.2 1.9-1.8 3.3-3.7 3.2l-27.5-1.8c-1.9-.1-3.3-1.8-3.2-3.7l.4-6.2Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.7 425.4 27.5 1.8-.1.7-27.5-1.8.1-.7Zm31.1 5.8-.4 6.2-.7-.1.4-6.1h.7Zm-4.5 9.7-27.5-1.8.1-.7 27.5 1.8-.1.7Zm-31-5.8.4-6.2h.6l-.4 6.2h-.6Zm3.6 4c-2.1-.1-3.7-1.9-3.6-4h.7c-.1 1.7 1.2 3.2 2.9 3.3v.7Zm31.5-1.7c-.1 2.1-1.9 3.7-4 3.5l.1-.6c1.7.1 3.1-1.2 3.3-2.9h.6Zm-3.2-10.3c2.1.2 3.7 2 3.6 4.1l-.7-.1c.1-1.7-1.2-3.2-2.9-3.3v-.7Zm-27.6-1.1c-1.7-.1-3.1 1.2-3.3 2.9h-.6c.1-2.1 1.9-3.7 4-3.6l-.1.7ZM556.5 431.5c.1-1.9 1.7-3.4 3.6-3.3l35.4 2.4c1.9.1 3.4 1.7 3.3 3.6l-.4 5.5c-.1 1.9-1.8 3.4-3.7 3.2l-35.4-2.3c-1.9-.1-3.3-1.7-3.2-3.6l.4-5.5Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.2 427.9 35.4 2.3-.1.7-35.4-2.3.1-.7Zm39 6.3-.4 5.5h-.7l.4-5.5h.7Zm-4.4 9-35.4-2.3v-.7l35.4 2.3v.7Zm-38.9-6.3.4-5.5h.6l-.3 5.5h-.7Zm3.5 4.1c-2.1-.2-3.7-2-3.5-4.1l.7.1c-.1 1.7 1.1 3.2 2.9 3.3l-.1.7Zm39.4-1.2c-.2 2.1-2 3.6-4 3.5v-.7c1.7.1 3.2-1.2 3.3-2.9l.7.1Zm-3.2-9.5c2.1.1 3.7 1.9 3.6 4h-.7c.1-1.7-1.2-3.2-2.9-3.3v-.7Zm-35.5-1.7c-1.7-.1-3.2 1.2-3.3 2.9h-.6c.1-2.1 1.9-3.7 4-3.5l-.1.6ZM517 444.7c.1-1.9 1.7-3.3 3.6-3.2l27.5 1.8c1.9.2 3.3 1.8 3.2 3.7l-.4 6.2c-.1 1.9-1.7 3.3-3.6 3.2l-27.5-1.8c-1.9-.1-3.4-1.8-3.3-3.7l.5-6.2Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.6 441.2 27.5 1.8v.7l-27.5-1.8v-.7Zm31 5.8-.4 6.2h-.7l.4-6.2h.7Zm-4.4 9.7-27.5-1.8v-.7l27.5 1.8v.7Zm-31-5.8.4-6.2h.7l-.4 6.2h-.7Zm3.5 4c-2.1-.1-3.6-1.9-3.5-4l.7.1c-.1 1.7 1.2 3.1 2.9 3.2l-.1.7Zm31.5-1.7c-.1 2.1-1.9 3.7-4 3.6v-.7c1.7.1 3.2-1.2 3.3-2.9h.7Zm-3.1-10.2c2.1.1 3.7 1.9 3.5 4l-.7-.1c.1-1.7-1.1-3.1-2.9-3.3l.1-.6Zm-27.5-1.1c-1.7-.1-3.2 1.2-3.3 2.9h-.7c.2-2.1 2-3.7 4.1-3.6l-.1.7Z",
    style: {
      fill: "#e2e8f0",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M51 319.7c-.5-3.6 2-7.1 5.6-7.6l488.6-75.6c3.7-.6 7.1 1.9 7.7 5.6l46.4 300.4c.6 3.6-1.9 7.1-5.6 7.6l-488.6 75.6c-3.6.6-7-1.9-7.6-5.6L51 319.7Z",
    style: {
      fill: "#dcdcde",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1 325.9c-.6-3.8 2.1-7.4 5.9-8l337-52.1c3.9-.6 7.5 2 8.1 5.9l6.9 44.9c.6 3.9-2 7.5-5.9 8.1l-337 52.1c-3.8.6-7.4-2-8-5.9l-7-45Z",
    style: {
      fill: "#94a3b8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.7 282.6c-.3-1.6.8-3 2.3-3.3l7-1c1.5-.3 3 .8 3.2 2.3l1.2 7.7c.2 1.5-.8 3-2.4 3.2l-6.9 1.1c-1.6.2-3-.8-3.2-2.4l-1.2-7.6ZM356 280c-.2-1.5.9-3 2.4-3.2l44.3-6.8c1.5-.3 2.9.8 3.2 2.3l1.2 7.7c.2 1.5-.9 3-2.4 3.2l-44.3 6.8c-1.5.3-2.9-.8-3.2-2.3L356 280Z",
    style: {
      fill: "#f6f8fc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7 359.3c-.1-.9.5-1.7 1.4-1.9l30.8-4.7c1-.2 1.8.4 2 1.4l4.7 30.8c.2.9-.5 1.8-1.4 1.9l-30.8 4.8c-.9.1-1.8-.5-1.9-1.4l-4.8-30.9Z",
    style: {
      fill: "#94a3b8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77 356.7 30.8-4.7.3 1.3-30.9 4.8-.2-1.4Zm33.6-2.8 4.7 30.9-1.3.2-4.8-30.8 1.4-.3Zm2.8 33.5-30.9 4.8-.2-1.4 30.8-4.8.3 1.4Zm-33.5 2.8-4.8-30.8 1.4-.3 4.8 30.9-1.4.2Zm2.7 2c-1.3.2-2.5-.7-2.7-2l1.4-.2c.1.5.6.9 1.1.8l.2 1.4Zm32.8-7.5c.2 1.3-.7 2.5-2 2.7l-.2-1.4c.5-.1.9-.6.8-1.1l1.4-.2Zm-7.5-32.8c1.3-.2 2.5.7 2.7 2l-1.3.2c-.1-.6-.6-.9-1.2-.8l-.2-1.4ZM77.3 358c-.5.1-.9.6-.8 1.1l-1.4.3c-.2-1.3.7-2.6 2-2.8l.2 1.4Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.2 335.8c-.3-1.5.8-3 2.3-3.2l2.8-.4c1.5-.3 3 .8 3.2 2.3l.5 2.8c.2 1.5-.9 3-2.4 3.2l-2.8.5c-1.5.2-3-.9-3.2-2.4l-.4-2.8Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.1 334.3c.2 0 .367.033.5.1.133 0 .267.033.4.1.133.133.233.267.3.4.067.133.133.3.2.5 0 .2.1.3.1.8.1.6.1.7.2.9v.5l-.2.4a1.583 1.583 0 0 1-.4.3c-.067.067-.233.133-.5.2-.2 0-.3.1-.8.1-.6.1-.7.1-.9.2-.2 0-.367-.033-.5-.1a.883.883 0 0 1-.4-.1 1.583 1.583 0 0 1-.3-.4c-.067-.067-.133-.233-.2-.5 0-.2 0-.3-.1-.8-.1-.6-.1-.7-.2-.9 0-.2.033-.367.1-.5 0-.133.033-.267.1-.4.133-.133.267-.233.4-.3.133-.067.3-.133.5-.2.2 0 .3 0 .8-.1.6-.1.7-.1.9-.2Zm-1.6.7c-.3 0-.4.1-.4.1-.133.067-.2.133-.2.2a1.175 1.175 0 0 0-.2.3v.4c0 .2.1.3.1.8.1.6.1.6.2.9 0 .2.1.3.1.3.067.133.133.233.2.3.067 0 .167.033.3.1h.4c.2 0 .3 0 .8-.1.6-.1.6-.1.9-.2.2 0 .3-.1.3-.1.133-.067.233-.133.3-.2 0-.067.033-.167.1-.3v-.4c0-.2 0-.2-.1-.8-.1-.6-.1-.6-.2-.9 0-.2-.1-.3-.1-.3-.067-.133-.133-.2-.2-.2a1.175 1.175 0 0 0-.3-.2h-.4c-.2 0-.2.1-.8.1-.6.1-.6.1-.8.2Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.6 336.4c.1.6-.3 1.1-.9 1.2-.6.1-1.1-.3-1.2-.9-.1-.6.3-1.1.9-1.2.6-.1 1.1.3 1.2.9Zm-.3.1c-.1-.4-.5-.7-.8-.6-.4 0-.7.4-.6.8 0 .4.4.6.8.6.4-.1.6-.5.6-.8Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.8 335.2c0 .2-.1.3-.3.3-.1 0-.2-.1-.2-.2-.1-.1 0-.3.2-.3.1 0 .2.1.3.2ZM388.3 334.1c-.2-1.6.8-3 2.4-3.2l2.8-.5c1.5-.2 2.9.9 3.2 2.4l.4 2.8c.2 1.5-.8 3-2.3 3.2l-2.8.4c-1.6.3-3-.8-3.3-2.3l-.4-2.8Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.2 333.7.1.1c.1 1.1-.5 2.6-2.1 2.8a2.57 2.57 0 0 1-1.4-.2h.2c.4-.067.733-.233 1-.5-.3 0-.7-.2-.9-.5h.2c.067 0 .133-.033.2-.1-.4 0-.7-.3-.8-.7a.423.423 0 0 0 .4 0c-.2-.1-.4-.3-.5-.6 0-.2.033-.367.1-.5.5.5 1.2.7 1.9.6-.067 0-.1-.033-.1-.1-.1-.5.3-1 .7-1 .267-.067.5-.033.7.1.2-.067.367-.167.5-.3 0 .267-.1.467-.3.6.2-.067.367-.133.5-.2-.067.2-.2.367-.4.5Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.5 332.4c-.3-1.6.8-3 2.3-3.3l2.8-.4c1.5-.2 3 .8 3.2 2.4l.5 2.8c.2 1.5-.9 2.9-2.4 3.2l-2.8.4c-1.5.2-3-.8-3.2-2.4l-.4-2.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6 331.6h-.4c-.3.1-.3.2-.3.4l.1.3.7-.1v.7l-.6.1.3 2.2-.8.1-.4-2.1h-.4l-.1-.7h.4v-.5c-.1-.6.1-.9.8-1 .3-.1.4-.1.7-.1v.7Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4 396 196 378.3l1.5 9.4-114.7 17.7-1.4-9.4Z",
    style: {
      fill: "#cbd4e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.9 395.3 1.3 8.2-1.5.2-4.3-4.6h-.1l.8 5.1-1.7.3-1.2-8.1 1.5-.2 4.3 4.5-.8-5.1 1.7-.3Zm5.4 7.6c-.6.067-1.133.033-1.6-.1-.467-.2-.867-.533-1.2-1-.333-.4-.533-.933-.6-1.6-.133-.6-.1-1.167.1-1.7.133-.467.4-.867.8-1.2.467-.333 1-.567 1.6-.7.6-.067 1.133 0 1.6.2.533.2.933.5 1.2.9.333.467.567 1 .7 1.6.067.6 0 1.167-.2 1.7a2.4 2.4 0 0 1-.8 1.3c-.4.333-.933.533-1.6.6Zm-.1-1.3c.267-.067.467-.2.6-.4.2-.133.3-.367.3-.7a2.034 2.034 0 0 0 0-.9c0-.4-.1-.733-.3-1a1.502 1.502 0 0 0-.5-.6c-.2-.133-.433-.167-.7-.1-.267.067-.5.2-.7.4-.133.133-.233.367-.3.7-.067.267-.067.6 0 1 .067.333.167.633.3.9.133.267.3.467.5.6.2.133.467.167.8.1Zm4.2.6-.9-6.1 1.6-.3.2 1.1c.067-.4.233-.733.5-1 .267-.2.6-.333 1-.4.467-.067.867-.033 1.2.1.267.2.5.467.7.8.067-.4.267-.733.6-1 .267-.267.633-.433 1.1-.5a2.355 2.355 0 0 1 1.5.3c.4.333.633.833.7 1.5l.7 4.1-1.7.2-.6-3.7c-.067-.333-.2-.567-.4-.7s-.433-.2-.7-.2c-.333.067-.567.2-.7.4a1.128 1.128 0 0 0-.1.8l.6 3.7-1.7.3-.6-3.8c0-.267-.1-.5-.3-.7-.2-.133-.433-.167-.7-.1a.68.68 0 0 0-.5.2 1.583 1.583 0 0 0-.3.4c-.067.2-.1.4-.1.6l.6 3.7-1.7.3Zm13-1.9c-.667.133-1.233.1-1.7-.1-.467-.2-.867-.5-1.2-.9-.333-.467-.533-1.033-.6-1.7-.133-.6-.1-1.167.1-1.7.133-.467.4-.867.8-1.2.4-.333.9-.567 1.5-.7.4-.067.8-.033 1.2.1.333.067.667.2 1 .4.267.2.5.5.7.9.2.333.367.767.5 1.3v.4l-4.1.7c.067.267.167.5.3.7.133.2.3.367.5.5.267.067.533.067.8 0 .2 0 .367-.033.5-.1s.267-.167.4-.3l.2-.4 1.5-.2c0 .4-.1.767-.3 1.1-.2.267-.467.533-.8.8-.4.2-.833.333-1.3.4Zm-1.8-2.5-.2-1v-.1l-1 .2.2 1 1-.1Zm2.4-1.4c-.067-.267-.167-.467-.3-.6a.964.964 0 0 0-.5-.4c-.2-.067-.4-.1-.6-.1-.267.067-.5.167-.7.3-.2.133-.333.333-.4.6-.067.2-.1.4-.1.6l2.6-.4Zm8.1 2.6c-.467.067-.9 0-1.3-.2-.4-.133-.733-.433-1-.9-.333-.4-.533-.967-.6-1.7-.133-.667-.1-1.267.1-1.8.133-.467.367-.833.7-1.1a2.07 2.07 0 0 1 1.2-.6c.333-.067.6-.033.8.1.267.067.5.167.7.3.133.133.267.3.4.5l-.5-3.1 1.7-.3 1.3 8.2-1.7.2-.1-1h-.1c-.067.2-.167.4-.3.6-.067.2-.233.367-.5.5-.2.133-.467.233-.8.3Zm.4-1.4c.267-.067.467-.2.6-.4.2-.133.333-.367.4-.7v-.9a3.58 3.58 0 0 0-.3-1 1.502 1.502 0 0 0-.6-.5c-.2-.133-.433-.167-.7-.1-.267.067-.5.167-.7.3-.133.2-.233.433-.3.7-.067.267-.067.6 0 1 .067.333.167.633.3.9.133.267.3.433.5.5.2.133.467.2.8.2Zm7.2.2c-.6.133-1.133.1-1.6-.1-.533-.2-.933-.533-1.2-1-.333-.4-.533-.9-.6-1.5-.133-.667-.1-1.233.1-1.7a2.4 2.4 0 0 1 .8-1.3c.4-.333.933-.533 1.6-.6.6-.133 1.133-.1 1.6.1.533.2.933.5 1.2.9.333.467.533 1 .6 1.6.133.667.1 1.233-.1 1.7a2.4 2.4 0 0 1-.8 1.3c-.4.333-.933.533-1.6.6Zm-.2-1.3c.333 0 .567-.1.7-.3.133-.2.233-.433.3-.7a2.513 2.513 0 0 0 0-1 3.605 3.605 0 0 0-.3-.9 1.502 1.502 0 0 0-.5-.6c-.2-.133-.433-.2-.7-.2-.333.067-.567.2-.7.4-.2.2-.3.433-.3.7a2.513 2.513 0 0 0 0 1c.067.333.167.633.3.9.133.267.3.467.5.6.2.133.433.167.7.1Zm6.9.2-1-6.1 1.7-.3.1 1.1h.1c.067-.4.2-.7.4-.9.267-.267.567-.433.9-.5h.5l.3 1.5h-.8c-.2.067-.4.167-.6.3-.2.133-.333.3-.4.5s-.1.433-.1.7l.6 3.4-1.7.3Zm7-1c-.6.133-1.133.1-1.6-.1-.533-.2-.933-.5-1.2-.9-.333-.467-.567-1-.7-1.6-.067-.667 0-1.233.2-1.7a2.4 2.4 0 0 1 .8-1.3c.4-.333.9-.533 1.5-.6.4-.067.8-.067 1.2 0 .333.067.667.2 1 .4.267.267.5.567.7.9.2.333.333.767.4 1.3l.1.5-4.1.6c0 .333.1.6.3.8.133.2.3.333.5.4.267.133.533.167.8.1.2-.067.367-.133.5-.2a.66.66 0 0 0 .3-.3c.133-.133.2-.267.2-.4l1.6-.1c0 .333-.1.667-.3 1-.2.333-.5.6-.9.8-.333.2-.767.333-1.3.4Zm-1.7-2.5-.2-1-1 .1.2 1.1 1-.2Zm2.4-1.5a2.55 2.55 0 0 0-.3-.6 3.26 3.26 0 0 0-.5-.4c-.2-.067-.433-.067-.7 0-.2 0-.4.1-.6.3-.2.133-.333.3-.4.5s-.1.4-.1.6l2.6-.4Zm7.7-1.9-1.6.4c0-.133-.067-.267-.2-.4-.067-.067-.2-.133-.4-.2h-.5c-.267.067-.467.167-.6.3-.2.133-.267.3-.2.5 0 .133.067.233.2.3.133.067.333.133.6.2h1.2c.6.067 1.067.2 1.4.4.333.2.533.533.6 1 .067.4 0 .767-.2 1.1-.2.333-.5.6-.9.8-.333.267-.767.433-1.3.5-.8.133-1.467.067-2-.2-.533-.267-.9-.667-1.1-1.2l1.7-.4c.067.267.2.433.4.5.2.133.467.167.8.1.267-.067.5-.167.7-.3a.68.68 0 0 0 .2-.5c0-.133-.1-.233-.3-.3a3.083 3.083 0 0 0-.6-.2h-1.1c-.6 0-1.067-.133-1.4-.4-.333-.267-.533-.633-.6-1.1-.067-.4 0-.733.2-1 .133-.333.4-.6.8-.8.333-.2.767-.367 1.3-.5.733-.067 1.367 0 1.9.2.467.267.8.667 1 1.2Zm4.1-2.4.2 1.3-1.1.2.4 2.9.2.4c.067.067.133.1.2.1h.5c.067-.067.133-.1.2-.1l.5 1.2-.4.2c-.133.067-.3.1-.5.1-.4.067-.767.067-1.1 0a1.28 1.28 0 0 1-.8-.5c-.2-.2-.333-.5-.4-.9l-.5-3.2-.8.2-.2-1.3.8-.1-.2-1.5 1.7-.3.2 1.5 1.1-.2Zm3.8 5.8c-.4.067-.767.033-1.1-.1a1.28 1.28 0 0 1-.8-.5c-.2-.2-.333-.5-.4-.9a2.034 2.034 0 0 1 0-.9c.133-.267.3-.5.5-.7.133-.133.333-.267.6-.4.267-.133.567-.233.9-.3.333-.067.6-.133.8-.2.2-.067.367-.133.5-.2.067-.067.1-.167.1-.3v-.1a.964.964 0 0 0-.4-.5c-.133-.133-.367-.167-.7-.1-.267.067-.5.167-.7.3-.133.133-.2.333-.2.6l-1.6.1c0-.4.1-.767.3-1.1.2-.267.467-.5.8-.7.333-.2.733-.333 1.2-.4.4-.067.733-.1 1-.1.333.067.633.167.9.3.267.133.5.3.7.5.2.267.333.567.4.9l.6 4.1-1.6.3-.1-.9h-.1c-.067.2-.167.4-.3.6a3.26 3.26 0 0 1-.5.4 3.948 3.948 0 0 1-.8.3Zm.3-1.3c.267 0 .467-.067.6-.2.2-.133.333-.3.4-.5s.1-.4.1-.6l-.1-.6c-.067 0-.133.033-.2.1-.133 0-.233.033-.3.1a.883.883 0 0 1-.4.1c-.067.067-.167.1-.3.1a3.86 3.86 0 0 1-.5.2l-.3.3c-.067.133-.067.3 0 .5 0 .2.1.333.3.4.2.133.433.167.7.1Zm7.9-2.8-.5-3.5 1.6-.2 1 6-1.6.3-.2-1.1h-.1c-.067.4-.233.733-.5 1s-.633.433-1.1.5c-.4.067-.8.033-1.2-.1a1.626 1.626 0 0 1-.8-.7c-.2-.333-.333-.733-.4-1.2l-.6-3.9 1.6-.2.6 3.5c.067.4.2.667.4.8.2.2.467.267.8.2.2 0 .4-.067.6-.2.133-.133.233-.3.3-.5.133-.2.167-.433.1-.7Zm3.4 2.1-.9-6 1.6-.3.2 1.1h.1c0-.4.133-.733.4-1 .2-.2.467-.333.8-.4h.3c.133-.067.233-.067.3 0l.2 1.5c-.067-.067-.167-.1-.3-.1a.883.883 0 0 0-.4.1c-.267 0-.5.067-.7.2-.133.133-.233.333-.3.6-.133.2-.167.4-.1.6l.5 3.5-1.7.2Zm6.2-.9c-.4.067-.767.067-1.1 0a1.28 1.28 0 0 1-.8-.5c-.2-.267-.333-.6-.4-1-.067-.333-.067-.6 0-.8.067-.267.2-.5.4-.7.2-.133.433-.267.7-.4.267-.133.567-.233.9-.3.333-.067.6-.133.8-.2.2-.067.333-.133.4-.2.133-.133.167-.267.1-.4 0-.267-.1-.433-.3-.5-.2-.133-.433-.167-.7-.1-.267 0-.5.1-.7.3a1.26 1.26 0 0 0-.3.5l-1.5.2c0-.4.1-.767.3-1.1.2-.267.467-.5.8-.7.333-.2.733-.367 1.2-.5h1c.333.067.633.133.9.2.267.133.5.333.7.6.133.267.233.567.3.9l.7 4.1-1.6.3-.2-.9c-.067.2-.167.4-.3.6a2.315 2.315 0 0 1-.6.4c-.2.133-.433.2-.7.2Zm.3-1.2c.2 0 .4-.067.6-.2.2-.133.333-.3.4-.5s.1-.4.1-.6l-.1-.7-.2.2c-.133 0-.233.033-.3.1a.883.883 0 0 1-.4.1c-.067.067-.167.1-.3.1a3.86 3.86 0 0 0-.5.2.66.66 0 0 0-.3.3.423.423 0 0 0 0 .4c0 .267.1.433.3.5.2.133.433.167.7.1Zm5.5-3.4.6 3.5-1.7.3-1-6.1 1.6-.2.2 1h.1c.067-.333.233-.633.5-.9.333-.267.7-.433 1.1-.5.467-.067.867-.033 1.2.1.333.133.6.367.8.7.267.333.433.733.5 1.2l.6 3.8-1.7.3-.6-3.6a.95.95 0 0 0-.4-.8c-.2-.2-.467-.267-.8-.2a3.083 3.083 0 0 0-.6.2 1.26 1.26 0 0 0-.3.5c-.067.2-.1.433-.1.7Zm8.1-3.9.2 1.3-1.1.2.4 2.9c.067.2.1.333.1.4.067.067.167.1.3.1.067.067.167.067.3 0h.2c.067-.067.133-.1.2-.1l.4 1.2a1.108 1.108 0 0 1-.8.3c-.4.133-.767.133-1.1 0-.333-.067-.6-.2-.8-.4-.2-.267-.333-.6-.4-1l-.5-3.2-.9.2-.2-1.3.9-.1-.2-1.5 1.6-.2.3 1.4 1.1-.2Zm4.7 5.6c-.6.133-1.133.1-1.6-.1-.533-.2-.967-.5-1.3-.9a5.68 5.68 0 0 1-.6-1.6c-.067-.667-.033-1.233.1-1.7.2-.533.5-.967.9-1.3.4-.333.9-.533 1.5-.6.4-.067.767-.067 1.1 0 .4.067.733.2 1 .4.333.2.6.5.8.9.2.333.333.767.4 1.3l.1.5-4.1.6c0 .333.067.6.2.8.2.2.4.333.6.4.2.067.467.1.8.1.133-.067.3-.133.5-.2a.66.66 0 0 0 .3-.3c.133-.133.2-.267.2-.4l1.6-.2c0 .4-.1.767-.3 1.1-.2.333-.5.6-.9.8-.333.2-.767.333-1.3.4Zm-1.7-2.5-.2-1-1 .1.2 1.1 1-.2Zm2.4-1.5a2.55 2.55 0 0 0-.3-.6.964.964 0 0 0-.5-.4c-.2-.067-.433-.067-.7 0-.267 0-.467.1-.6.3-.2.133-.333.3-.4.5s-.1.4-.1.6l2.6-.4Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.4 408.9 80.5-12.4 1.1 6.9-80.5 12.5-1.1-7ZM85.8 424.2 313.3 389l2.2 14-227.6 35.2-2.1-14ZM383.4 378.2l31-4.8 2.1 13.9-31 4.8-2.1-13.9Z",
    style: {
      fill: "#cbd4e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.1 452.1 86-13.3 1.7 10.5-86.1 13.3-1.6-10.5Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 470.9c-.3-1.5.8-2.9 2.3-3.2l73.5-11.3c1.5-.3 3 .8 3.2 2.3l6.1 39.7c.3 1.6-.8 3-2.3 3.3L102.3 513c-1.5.3-2.9-.8-3.2-2.3L93 470.9Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.4 471.7 19.8-3.1 1.3 8.4-19.8 3-1.3-8.3ZM98.9 481.4l76.3-11.8 1.1 7-76.3 11.8-1.1-7ZM102 501.7l19.5-3.1 1.1 7-19.5 3-1.1-6.9ZM165.7 491.8l7-1.1 1 7-6.9 1.1-1.1-7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2 458.1c-.3-1.6.8-3 2.3-3.3l73.5-11.3c1.5-.2 3 .8 3.2 2.3l6.1 39.8c.3 1.5-.8 3-2.3 3.2l-73.5 11.4c-1.5.2-2.9-.9-3.2-2.4l-6.1-39.7Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.6 458.8 19.8-3.1 1.3 8.4-19.8 3.1-1.3-8.4ZM182.1 468.6l76.3-11.8 1.1 6.9-76.3 11.8-1.1-6.9ZM185.2 488.8l19.5-3 1.1 6.9-19.5 3.1-1.1-7ZM248.9 478.9l7-1 1 6.9-6.9 1.1-1.1-7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.4 445.2c-.3-1.5.8-3 2.3-3.2l73.5-11.4c1.5-.2 3 .8 3.2 2.4l6.1 39.7c.3 1.5-.8 3-2.3 3.2l-73.5 11.4c-1.5.2-2.9-.8-3.2-2.4l-6.1-39.7Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.8 445.9 19.8-3 1.3 8.3-19.8 3.1-1.3-8.4ZM265.3 455.7l76.3-11.8 1.1 7-76.3 11.8-1.1-7ZM268.4 475.9l19.5-3 1.1 7-19.5 3-1.1-7ZM332.1 466.1l7-1.1 1 7-6.9 1-1.1-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.6 432.3c-.3-1.5.8-3 2.3-3.2l73.5-11.3c1.5-.3 3 .8 3.2 2.3l6.1 39.7c.3 1.6-.8 3-2.3 3.3l-73.5 11.3c-1.5.3-2.9-.8-3.2-2.3l-6.1-39.8Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347 433.1 19.8-3.1 1.3 8.4-19.8 3-1.3-8.3ZM348.5 442.8l76.3-11.8 1.1 7-76.3 11.8-1.1-7ZM351.6 463l19.5-3 1.1 7-19.5 3-1.1-7ZM415.3 453.2l7-1.1 1.1 7-7 1.1-1.1-7ZM101.7 527.4l86.1-13.3 1.6 10.4-86.1 13.3-1.6-10.4Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 546.2c-.2-1.5.8-3 2.4-3.2l101.2-15.7c1.5-.2 2.9.9 3.2 2.4l8.4 54.4c.2 1.5-.8 2.9-2.4 3.2l-101.2 15.6c-1.5.3-2.9-.8-3.2-2.3l-8.4-54.4Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109 547 19.9-3.1 1.3 8.4-19.9 3-1.3-8.3ZM110.5 556.7l98.4-15.2 1.1 7-98.4 15.2-1.1-7ZM115.9 591.6l19.5-3.1 1.1 7-19.5 3-1.1-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6 529.1c-.3-1.6.8-3 2.3-3.3l101.2-15.6c1.5-.3 3 .8 3.2 2.3l8.4 54.4c.3 1.5-.8 3-2.3 3.2l-101.2 15.7c-1.6.2-3-.8-3.2-2.4l-8.4-54.3Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220 529.8 19.8-3.1 1.3 8.4-19.9 3.1-1.2-8.4ZM221.5 539.6l98.4-15.3 1 7-98.4 15.2-1-6.9ZM226.9 574.4l19.5-3 1 7-19.5 3-1-7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5 511.9c-.2-1.5.8-3 2.3-3.2L430 493c1.6-.2 3 .8 3.2 2.4l8.5 54.3c.2 1.6-.9 3-2.4 3.3l-101.2 15.6c-1.5.3-3-.8-3.2-2.3l-8.4-54.4Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.9 512.6 19.9-3 1.2 8.3-19.8 3.1-1.3-8.4ZM332.4 522.4l98.4-15.2 1.1 7-98.4 15.2-1.1-7ZM337.8 557.3l19.5-3.1 1.1 7-19.5 3-1.1-6.9Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.6 267.8c-.4-2.3 1.2-4.5 3.5-4.8l121.7-18.8c2.3-.4 4.4 1.2 4.8 3.5l45 291.3c.4 2.3-1.2 4.5-3.5 4.9l-121.6 18.8c-2.3.3-4.5-1.2-4.8-3.6l-45.1-291.3Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5 273c-.3-1.9 1.1-3.7 3-4l109.1-16.9c1.9-.3 3.7 1 4 2.9l1.1 7c.3 1.9-1.1 3.7-3 4l-109.1 16.9c-1.9.3-3.7-1-4-2.9l-1.1-7ZM428.1 296l53-8.2 1.3 8.4-53 8.2-1.3-8.4ZM430.6 312c-.3-1.9 1-3.7 2.9-4l27.9-4.3c1.9-.3 3.7 1 4 2.9l1 6.3c.3 1.9-1 3.7-2.9 4l-27.9 4.3c-2 .3-3.8-1-4.1-2.9l-.9-6.3Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.5 307.7 27.9-4.4.1.7-27.9 4.4-.1-.7Zm32.3-1.1 1 6.3-.7.1-1-6.3.7-.1Zm-2.3 10.7-27.9 4.3-.1-.7 27.9-4.3.1.7Zm-32.3 1.1-1-6.3.7-.1 1 6.3-.7.1Zm4.4 3.2c-2.1.3-4.1-1.1-4.4-3.2l.7-.2c.3 1.8 1.9 3 3.6 2.7l.1.7Zm31.1-8.7c.4 2.1-1.1 4.1-3.2 4.4l-.1-.7c1.7-.3 2.9-1.9 2.6-3.6l.7-.1Zm-5.4-9.5c2.2-.4 4.1 1.1 4.5 3.2l-.7.1c-.3-1.7-1.9-2.9-3.6-2.7l-.2-.6Zm-27.8 5.1c-1.8.2-2.9 1.8-2.7 3.6l-.7.1c-.3-2.1 1.2-4.1 3.3-4.4l.1.7ZM469.6 306c-.3-1.9 1-3.7 3-4l35.8-5.6c2-.3 3.8 1 4.1 3l.8 5.5c.3 2-1 3.8-2.9 4.1l-35.9 5.5c-1.9.3-3.7-1-4-2.9l-.9-5.6Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.5 301.6 35.9-5.5.1.7-35.9 5.5-.1-.7Zm40.3-2.3.9 5.6-.7.1-.9-5.6.7-.1Zm-2.3 10-35.9 5.6-.1-.7 35.8-5.6.2.7Zm-40.3 2.3-.8-5.5.7-.2.8 5.6-.7.1Zm4.5 3.3c-2.2.3-4.1-1.2-4.5-3.3l.7-.1c.3 1.7 1.9 2.9 3.6 2.7l.2.7Zm39.2-10c.3 2.1-1.1 4.1-3.3 4.4l-.1-.7c1.8-.3 2.9-1.9 2.7-3.6l.7-.1Zm-5.3-8.8c2.1-.4 4.1 1.1 4.4 3.2l-.7.1c-.2-1.7-1.9-2.9-3.6-2.6l-.1-.7Zm-35.8 6.2c-1.7.3-2.9 1.9-2.6 3.6l-.7.2c-.4-2.2 1.1-4.1 3.2-4.5l.1.7ZM433.1 328.1c-.3-2 1-3.8 2.9-4.1l27.9-4.3c1.9-.3 3.7 1 4 3l1 6.2c.3 2-1 3.8-3 4.1l-27.8 4.3c-2 .3-3.8-1-4.1-3l-.9-6.2Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436 323.7 27.8-4.3.1.7-27.8 4.3-.1-.7Zm32.3-1.1.9 6.3-.7.1-.9-6.3.7-.1Zm-2.3 10.7-27.9 4.3-.1-.7 27.9-4.3.1.7Zm-32.3 1.1-1-6.3.7-.1 1 6.3-.7.1Zm4.4 3.2c-2.1.4-4.1-1.1-4.4-3.2l.7-.1c.2 1.7 1.9 2.9 3.6 2.6l.1.7Zm31.1-8.7c.3 2.1-1.1 4.1-3.2 4.4l-.1-.7c1.7-.3 2.9-1.9 2.6-3.6l.7-.1Zm-5.4-9.5c2.1-.3 4.1 1.1 4.5 3.2l-.7.1c-.3-1.7-1.9-2.9-3.7-2.6l-.1-.7Zm-27.7 5c-1.8.3-3 1.9-2.7 3.6l-.7.1c-.3-2.1 1.1-4.1 3.3-4.4l.1.7ZM472.1 322c-.3-1.9 1-3.7 2.9-4l22-3.4c1.9-.3 3.7 1 4 2.9l1 6.3c.3 1.9-1 3.7-3 4l-21.9 3.4c-1.9.3-3.7-1-4-2.9l-1-6.3Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475 317.6 21.9-3.3.1.6-21.9 3.4-.1-.7Zm26.4-.1.9 6.3-.7.1-.9-6.3.7-.1Zm-2.3 10.7-22 3.4-.1-.7 22-3.4.1.7Zm-26.4.2-1-6.3.7-.1 1 6.2-.7.2Zm4.4 3.3c-2.1.3-4.1-1.1-4.4-3.3l.7-.1c.3 1.8 1.9 3 3.6 2.7l.1.7Zm25.2-7.8c.4 2.1-1.1 4.1-3.2 4.4l-.1-.7c1.7-.3 2.9-1.9 2.6-3.6l.7-.1Zm-5.4-9.5c2.1-.4 4.1 1.1 4.5 3.2l-.7.1c-.3-1.7-1.9-2.9-3.7-2.6l-.1-.7Zm-21.8 4.1c-1.7.2-2.9 1.8-2.7 3.6l-.7.1c-.3-2.1 1.2-4.1 3.3-4.4l.1.7ZM435.5 344.1c-.3-1.9 1.1-3.7 3-4l27.9-4.3c1.9-.3 3.7 1 4 2.9l1 6.3c.3 1.9-1.1 3.7-3 4l-27.9 4.3c-1.9.3-3.7-1-4-2.9l-1-6.3Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.4 339.7 27.9-4.3.1.7-27.9 4.3-.1-.7Zm32.3-1.1 1 6.3-.7.1-1-6.3.7-.1Zm-2.2 10.7-27.9 4.4-.1-.7 27.9-4.3.1.6Zm-32.3 1-1-6.3.7-.1 1 6.3-.7.1Zm4.4 3.3c-2.1.3-4.1-1.2-4.4-3.3l.7-.1c.2 1.7 1.8 2.9 3.6 2.7l.1.7Zm31.1-8.8c.3 2.1-1.1 4.1-3.2 4.4l-.2-.7c1.8-.2 3-1.8 2.7-3.6l.7-.1Zm-5.4-9.5c2.1-.3 4.1 1.1 4.4 3.3l-.7.1c-.2-1.8-1.9-3-3.6-2.7l-.1-.7Zm-27.8 5c-1.7.3-2.9 1.9-2.6 3.6l-.7.1c-.3-2.1 1.1-4 3.2-4.4l.1.7ZM477.4 337.6c-.3-1.9 1-3.7 2.9-4l40.8-6.3c1.9-.3 3.7 1 4 2.9l.9 5.6c.3 1.9-1.1 3.7-3 4l-40.8 6.3c-1.9.3-3.7-1-4-2.9l-.8-5.6Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.2 333.2 40.8-6.3.1.7-40.7 6.3-.2-.7Zm45.2-3 .8 5.6-.7.1-.8-5.6.7-.1Zm-2.4 10-40.8 6.3-.1-.7 40.8-6.3.1.7Zm-45.2 3.1-.9-5.6.7-.1.9 5.5-.7.2Zm4.4 3.3c-2.1.3-4.1-1.1-4.4-3.3l.7-.1c.2 1.8 1.9 3 3.6 2.7l.1.7Zm44-10.7c.3 2.1-1.1 4.1-3.2 4.4l-.1-.7c1.7-.3 2.9-1.9 2.6-3.6l.7-.1Zm-5.3-8.8c2.1-.4 4.1 1.1 4.4 3.2l-.7.1c-.2-1.7-1.8-2.9-3.6-2.7l-.1-.6Zm-40.6 7.1c-1.8.2-3 1.8-2.7 3.6l-.7.1c-.3-2.1 1.1-4.1 3.3-4.4l.1.7ZM438.8 365l49.5-7.7 1.3 8.4-49.5 7.7-1.3-8.4Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.9,
    cy: 379.9,
    r: 2.1,
    style: {
      fill: "#cbd4e1",
      stroke: "#cbd4e1",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.1 376.3 19.8-3.1.9 5.6-19.9 3-.8-5.5Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.4,
    cy: 389.7,
    r: 2.1,
    style: {
      fill: "#cbd4e1",
      stroke: "#cbd4e1",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.6 386 26.5-4.1.8 5.6-26.5 4.1-.8-5.6Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 399.4,
    r: 2.1,
    style: {
      fill: "#cbd4e1",
      stroke: "#cbd4e1",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.1 395.8 28.6-4.5.8 5.6-28.5 4.4-.9-5.5ZM446.3 413.8l45.7-7.1 1.3 8.4-45.7 7-1.3-8.3ZM448.8 429.8c-.3-1.9 1-3.7 2.9-4l27.9-4.3c1.9-.3 3.7 1 4 2.9l1 6.3c.3 1.9-1 3.7-2.9 4l-27.9 4.3c-1.9.3-3.7-1-4-2.9l-1-6.3Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.7 425.4 27.9-4.3.1.7-27.9 4.3-.1-.7Zm32.3-1 1 6.2-.7.2-1-6.3.7-.1Zm-2.3 10.7-27.8 4.3-.2-.7 27.9-4.3.1.7Zm-32.3 1.1-.9-6.3.6-.1 1 6.2-.7.2Zm4.4 3.3c-2.1.3-4.1-1.1-4.4-3.3l.7-.1c.3 1.8 1.9 3 3.6 2.7l.1.7Zm31.2-8.8c.3 2.2-1.2 4.1-3.3 4.5l-.1-.7c1.7-.3 2.9-1.9 2.7-3.6l.7-.2Zm-5.4-9.6c2.1-.3 4.1 1.2 4.4 3.3l-.7.1c-.3-1.7-1.9-2.9-3.6-2.7l-.1-.7Zm-27.8 5c-1.7.3-2.9 1.9-2.7 3.7l-.6.1c-.4-2.1 1.1-4.1 3.2-4.4l.1.6ZM487.8 423.8c-.3-1.9 1-3.7 3-4l35.9-5.6c1.9-.3 3.7 1 4 2.9l.9 5.6c.3 1.9-1.1 3.8-3 4l-35.9 5.6c-1.9.3-3.7-1-4-2.9l-.9-5.6Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.7 419.4 35.9-5.5.1.7-35.9 5.5-.1-.7Zm40.3-2.3.9 5.6-.7.1-.8-5.6.6-.1Zm-2.4 10-35.9 5.6-.1-.7 35.9-5.6.1.7Zm-40.4 2.3-.8-5.6.7-.1.8 5.6-.7.1Zm4.5 3.3c-2.1.3-4.1-1.2-4.5-3.3l.7-.1c.3 1.7 1.9 2.9 3.7 2.7l.1.7Zm39.1-10c.3 2.1-1.1 4.1-3.2 4.4l-.1-.7c1.7-.3 2.9-1.9 2.6-3.6l.7-.1Zm-5.3-8.8c2.1-.4 4.1 1.1 4.4 3.2l-.7.1c-.2-1.7-1.8-2.9-3.6-2.6l-.1-.7Zm-35.8 6.2c-1.7.3-2.9 1.9-2.6 3.6l-.7.1c-.3-2.1 1.1-4.1 3.2-4.4l.1.7ZM451.3 445.8c-.3-1.9 1-3.7 2.9-4l27.9-4.3c1.9-.3 3.7 1 4 3l1 6.2c.3 2-1 3.8-2.9 4.1l-27.9 4.3c-2 .3-3.8-1.1-4.1-3l-.9-6.3Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.2 441.5 27.8-4.3.2.7-27.9 4.3-.1-.7Zm32.3-1.1 1 6.3-.7.1-1-6.3.7-.1Zm-2.3 10.7-27.9 4.3-.1-.7 27.9-4.3.1.7Zm-32.3 1.1-1-6.3.7-.1 1 6.3-.7.1Zm4.4 3.2c-2.1.3-4.1-1.1-4.4-3.2l.7-.1c.3 1.7 1.9 2.9 3.6 2.6l.1.7Zm31.1-8.7c.4 2.1-1.1 4.1-3.2 4.4l-.1-.7c1.7-.3 2.9-1.9 2.6-3.6l.7-.1Zm-5.4-9.5c2.2-.4 4.1 1.1 4.5 3.2l-.7.1c-.3-1.7-1.9-2.9-3.6-2.6l-.2-.7Zm-27.8 5c-1.8.2-2.9 1.9-2.7 3.6l-.7.1c-.3-2.1 1.2-4.1 3.3-4.4l.1.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.9 286.7c0-3.643-2.957-6.6-6.6-6.6H122.5a6.603 6.603 0 0 0-6.6 6.6V586c0 3.643 2.957 6.6 6.6 6.6h486.8c3.643 0 6.6-2.957 6.6-6.6V286.7Z",
    style: {
      fill: "#f6f8fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3 291.2c0-2.318-1.882-4.2-4.2-4.2H127a4.202 4.202 0 0 0-4.2 4.2v290.2c0 2.318 1.882 4.2 4.2 4.2h121.1c2.318 0 4.2-1.882 4.2-4.2V291.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4 307.8c0-3.808-3.092-6.9-6.9-6.9h-87.9a6.904 6.904 0 0 0-6.9 6.9v34.8c0 3.808 3.092 6.9 6.9 6.9h87.9c3.808 0 6.9-3.092 6.9-6.9v-34.8Z",
    style: {
      fill: "#94a3b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.2 307.9c0-1.545-1.255-2.8-2.8-2.8h-4.1a2.802 2.802 0 0 0-2.8 2.8v4.1c0 1.545 1.255 2.8 2.8 2.8h4.1c1.545 0 2.8-1.255 2.8-2.8v-4.1Z",
    style: {
      fill: "#f6f8fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4 307.5c.267.067.467.133.6.2.133 0 .267.067.4.2s.233.3.3.5c.067.133.1.333.1.6v2c0 .2 0 .4-.1.6a1.583 1.583 0 0 1-.3.4 1.583 1.583 0 0 1-.4.3c-.133.067-.333.1-.6.1h-2c-.267 0-.467-.033-.6-.1a1.583 1.583 0 0 1-.4-.3 1.583 1.583 0 0 1-.3-.4c-.067-.2-.1-.4-.1-.6v-2c0-.267.033-.467.1-.6.067-.2.167-.367.3-.5.133-.133.267-.2.4-.2.133-.067.333-.133.6-.2h2Zm-2 .5c-.2 0-.4 0-.4.1-.133 0-.233.033-.3.1a1.175 1.175 0 0 1-.2.3c0 .1-.1.2-.1.5v1.9c0 .3.1.4.1.5.067.133.133.233.2.3.067.067.167.133.3.2h.4c.3.1.3.1 1 .1.6 0 .7 0 1-.1h.4c.133-.067.233-.133.3-.2.067-.067.133-.167.2-.3 0-.1.1-.2.1-.5V309c0-.3-.1-.4-.1-.5a1.175 1.175 0 0 1-.2-.3c-.067-.067-.167-.1-.3-.1-.1-.1-.2-.1-.4-.1h-2Z",
    style: {
      fill: "#f6f8fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6 310c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2.5-1.3 1.2-1.3 1.2.6 1.2 1.3Zm-.4 0c0-.5-.4-.8-.8-.8s-.8.3-.8.8c0 .4.4.8.8.8s.8-.4.8-.8Z",
    style: {
      fill: "#f6f8fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 308.7c0 .1-.1.3-.3.3-.2 0-.3-.2-.3-.3 0-.2.1-.3.3-.3.2 0 .3.1.3.3Z",
    style: {
      fill: "#f6f8fc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7 307.9c0-1.545-1.255-2.8-2.8-2.8h-4.1a2.802 2.802 0 0 0-2.8 2.8v4.1c0 1.545 1.255 2.8 2.8 2.8h4.1c1.545 0 2.8-1.255 2.8-2.8v-4.1Z",
    style: {
      fill: "#f6f8fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.8 308.9v.2c0 1.3-1 2.8-2.8 2.8-.6 0-1.1-.2-1.5-.5.067.067.133.1.2.1.5 0 .9-.2 1.2-.5-.4 0-.8-.3-.9-.7.067.067.133.1.2.1s.167-.033.3-.1c-.5-.1-.8-.5-.8-1l.4.2c-.3-.2-.4-.5-.4-.9 0-.2.033-.367.1-.5.5.6 1.2 1 2.1 1.1-.067-.067-.1-.167-.1-.3 0-.5.5-1 1-1 .3 0 .6.2.8.4.2-.067.4-.167.6-.3-.067.267-.2.467-.4.6.2-.067.367-.133.5-.2-.133.2-.3.367-.5.5ZM234.2 307.9c0-1.545-1.255-2.8-2.8-2.8h-4.1a2.802 2.802 0 0 0-2.8 2.8v4.1c0 1.545 1.255 2.8 2.8 2.8h4.1c1.545 0 2.8-1.255 2.8-2.8v-4.1Z",
    style: {
      fill: "#f6f8fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5 308.4h-.5c-.3 0-.3.1-.3.3v.4h.8l-.1.8h-.7v2.5h-1v-2.5h-.5v-.8h.5v-.5c0-.7.3-1.1 1.1-1.1.3 0 .5.1.8.1l-.1.8Z",
    style: {
      fill: "#f6f8fc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.7,
    cy: 341.9,
    r: 1.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.6,
    cy: 341.9,
    r: 1.4,
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.4,
    cy: 341.9,
    r: 1.4,
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5 331.5c0-.938-.762-1.7-1.7-1.7h-30.6c-.938 0-1.7.762-1.7 1.7v30.6c0 .938.762 1.7 1.7 1.7h30.6c.938 0 1.7-.762 1.7-1.7v-30.6Z",
    style: {
      fill: "#94a3b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2 329.1h30.7v1.3h-30.7v-1.3Zm33.1 2.4v30.7h-1.4v-30.7h1.4Zm-2.4 33.1h-30.7v-1.4h30.7v1.4Zm-33-2.4v-30.7h1.3v30.7h-1.3Zm2.4 2.4c-1.3 0-2.4-1.1-2.4-2.4h1.4c0 .6.5 1 1 1v1.4Zm33.1-2.4c0 1.3-1.1 2.4-2.4 2.4v-1.4c.5 0 1-.4 1-1h1.4Zm-2.4-33c1.3 0 2.4 1 2.4 2.3H204c0-.5-.4-.9-1-.9v-1.4Zm-30.7 1.3c-.5 0-1 .5-1 1H170c0-1.3 1-2.3 2.3-2.3v1.3Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.8 367.9 89.5.1v9.3h-89.5v-9.4ZM170.2 378.7h34.7v5.9h-34.7zM177.5 387.4h20.1v5.9h-20.1z",
    style: {
      fill: "#cbd4e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.3 407.9c0-1.932-1.568-3.5-3.5-3.5H133.2a3.501 3.501 0 0 0-3.5 3.5v6.9c0 1.932 1.568 3.5 3.5 3.5h108.6c1.932 0 3.5-1.568 3.5-3.5v-6.9Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M129.7 430.8h52.8v8.3h-52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4 446.8c0-1.932-1.568-3.5-3.5-3.5h-27.7a3.501 3.501 0 0 0-3.5 3.5v6.2c0 1.932 1.568 3.5 3.5 3.5h27.7c1.932 0 3.5-1.568 3.5-3.5v-6.2Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.2 442.9 27.8.1v.6h-27.8v-.7Zm31.6 3.9v6.2h-.7v-6.2h.7Zm-3.8 10h-27.8v-.7H161v.7Zm-31.6-3.8v-6.2h.7v6.2h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.7 1.4 3.1 3.1 3.1v.7Zm31.6-3.8c0 2.1-1.7 3.8-3.8 3.8v-.7c1.7 0 3.1-1.4 3.1-3.1h.7Zm-3.8-10c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.8-1.4-3.2-3.1-3.2v-.6Zm-27.8.7c-1.7 0-3.1 1.4-3.1 3.2h-.7c0-2.1 1.7-3.9 3.8-3.9v.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3 446.8c0-1.932-1.568-3.5-3.5-3.5h-35.7a3.501 3.501 0 0 0-3.5 3.5v5.5c0 1.932 1.568 3.5 3.5 3.5h35.7c1.932 0 3.5-1.568 3.5-3.5v-5.5Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.1 442.9 35.8.1v.6h-35.8v-.7Zm39.6 3.9v5.5h-.7v-5.5h.7Zm-3.8 9.3h-35.8v-.7h35.8v.7Zm-39.6-3.8v-5.5h.7v5.5h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.8 1.4 3.2 3.1 3.2v.6Zm39.6-3.9c0 2.1-1.7 3.9-3.8 3.9v-.7c1.7 0 3.1-1.4 3.1-3.2h.7Zm-3.8-9.3c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.8-1.4-3.1-3.1-3.1v-.7Zm-35.8.6c-1.7 0-3.1 1.4-3.1 3.2h-.7c0-2.1 1.7-3.8 3.8-3.8v.6Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4 462.8c0-1.932-1.568-3.5-3.5-3.5h-27.7a3.501 3.501 0 0 0-3.5 3.5v6.2c0 1.932 1.568 3.5 3.5 3.5h27.7c1.932 0 3.5-1.568 3.5-3.5v-6.2Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 458.9H161v.7h-27.8v-.7Zm31.6 3.8v6.3h-.7v-6.3h.7Zm-3.8 10.1h-27.8v-.7H161v.7Zm-31.6-3.8v-6.3h.7v6.3h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.7 1.4 3.1 3.1 3.1v.7Zm31.6-3.8c0 2.1-1.7 3.8-3.8 3.8v-.7c1.7 0 3.1-1.4 3.1-3.1h.7Zm-3.8-10.1c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.7-1.4-3.1-3.1-3.1v-.7Zm-27.8.7c-1.7 0-3.1 1.4-3.1 3.1h-.7c0-2.1 1.7-3.8 3.8-3.8v.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4 462.8c0-1.932-1.568-3.5-3.5-3.5h-21.8a3.501 3.501 0 0 0-3.5 3.5v6.2c0 1.932 1.568 3.5 3.5 3.5h21.8c1.932 0 3.5-1.568 3.5-3.5v-6.2Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1 458.9H194v.7h-21.9v-.7Zm25.7 3.8v6.3h-.7v-6.3h.7Zm-3.8 10.1h-21.9v-.7H194v.7Zm-25.7-3.8v-6.3h.7v6.3h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.7 1.4 3.1 3.1 3.1v.7Zm25.7-3.8c0 2.1-1.7 3.8-3.8 3.8v-.7c1.7 0 3.1-1.4 3.1-3.1h.7Zm-3.8-10.1c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.7-1.4-3.1-3.1-3.1v-.7Zm-21.9.7c-1.7 0-3.1 1.4-3.1 3.1h-.7c0-2.1 1.7-3.8 3.8-3.8v.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4 478.7c0-1.932-1.568-3.5-3.5-3.5h-27.7a3.501 3.501 0 0 0-3.5 3.5v6.2c0 1.932 1.568 3.5 3.5 3.5h27.7c1.932 0 3.5-1.568 3.5-3.5v-6.2Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 474.9H161v.7h-27.8v-.7Zm31.6 3.8v6.3h-.7v-6.3h.7Zm-3.8 10.1h-27.8v-.7H161v.7Zm-31.6-3.8v-6.3h.7v6.3h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.7 1.4 3.1 3.1 3.1v.7Zm31.6-3.8c0 2.1-1.7 3.8-3.8 3.8v-.7c1.7 0 3.1-1.4 3.1-3.1h.7Zm-3.8-10.1c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.7-1.4-3.1-3.1-3.1v-.7Zm-27.8.7c-1.7 0-3.1 1.4-3.1 3.1h-.7c0-2.1 1.7-3.8 3.8-3.8v.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 478.7c0-1.932-1.568-3.5-3.5-3.5h-40.6a3.501 3.501 0 0 0-3.5 3.5v5.5c0 1.932 1.568 3.5 3.5 3.5h40.6c1.932 0 3.5-1.568 3.5-3.5v-5.5Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9 474.9h40.6v.7h-40.6v-.7Zm44.4 3.8v5.6h-.7v-5.6h.7Zm-3.8 9.4h-40.6v-.7h40.6v.7Zm-44.4-3.8v-5.6h.7v5.6h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.7 1.4 3.1 3.1 3.1v.7Zm44.4-3.8c0 2.1-1.7 3.8-3.8 3.8v-.7c1.7 0 3.1-1.4 3.1-3.1h.7Zm-3.8-9.4c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.7-1.4-3.1-3.1-3.1v-.7Zm-40.6.7c-1.7 0-3.1 1.4-3.1 3.1h-.7c0-2.1 1.7-3.8 3.8-3.8v.7ZM129.7 499.5H179v8.4h-49.3z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 514.8,
    r: 2.1,
    style: {
      fill: "#cbd4e1",
      stroke: "#cbd4e1",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M138.1 512h19.8v5.6h-19.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 524.5,
    r: 2.1,
    style: {
      fill: "#cbd4e1",
      stroke: "#cbd4e1",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M138.1 521.8h26.4v5.5h-26.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 534.3,
    r: 2.1,
    style: {
      fill: "#cbd4e1",
      stroke: "#cbd4e1",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M138.1 531.5h28.5v5.5h-28.5zM129.7 548.2h45.5v8.3h-45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4 564.2c0-1.932-1.568-3.5-3.5-3.5h-27.7a3.501 3.501 0 0 0-3.5 3.5v6.2c0 1.932 1.568 3.5 3.5 3.5h27.7c1.932 0 3.5-1.568 3.5-3.5v-6.2Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 560.3H161v.7h-27.8v-.7Zm31.6 3.8v6.3h-.7v-6.3h.7Zm-3.8 10.1h-27.8v-.7H161v.7Zm-31.6-3.8v-6.3h.7v6.3h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.7 1.4 3.1 3.1 3.1v.7Zm31.6-3.8c0 2.1-1.7 3.8-3.8 3.8v-.7c1.7 0 3.1-1.4 3.1-3.1h.7Zm-3.8-10.1c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.7-1.4-3.1-3.1-3.1v-.7Zm-27.8.7c-1.7 0-3.1 1.4-3.1 3.1h-.7c0-2.1 1.7-3.8 3.8-3.8v.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3 564.2c0-1.932-1.568-3.5-3.5-3.5h-35.7a3.501 3.501 0 0 0-3.5 3.5v5.5c0 1.932 1.568 3.5 3.5 3.5h35.7c1.932 0 3.5-1.568 3.5-3.5v-5.5Z",
    style: {
      fill: "#e2e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1 560.3h35.8v.7h-35.8v-.7Zm39.6 3.8v5.6h-.7v-5.6h.7Zm-3.8 9.4h-35.8v-.7h35.8v.7Zm-39.6-3.8v-5.6h.7v5.6h-.7Zm3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8h.7c0 1.7 1.4 3.1 3.1 3.1v.7Zm39.6-3.8c0 2.1-1.7 3.8-3.8 3.8v-.7c1.7 0 3.1-1.4 3.1-3.1h.7Zm-3.8-9.4c2.1 0 3.8 1.7 3.8 3.8h-.7c0-1.7-1.4-3.1-3.1-3.1v-.7Zm-35.8.7c-1.7 0-3.1 1.4-3.1 3.1h-.7c0-2.1 1.7-3.8 3.8-3.8v.7Z",
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbd4e1",
      fillRule: "nonzero"
    },
    d: "M259.3 287H486v13.9H259.3zM578 287h30.9v13.9H578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M259.2 315h85.7v10.4h-85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5 333.8c0-1.545-1.255-2.8-2.8-2.8H262a2.802 2.802 0 0 0-2.8 2.8V431c0 1.545 1.255 2.8 2.8 2.8h78.7c1.545 0 2.8-1.255 2.8-2.8v-97.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.3 338c0-1.545-1.255-2.8-2.8-2.8h-70.4a2.802 2.802 0 0 0-2.8 2.8v47.9c0 1.545 1.255 2.8 2.8 2.8h70.4c1.545 0 2.8-1.255 2.8-2.8V338Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M263.3 392.8h19.8v8.3h-19.8zM263.3 402.5h76.1v7h-76.1zM263.3 422.7h19.5v6.9h-19.5zM332.3 422.7h7v6.9h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 333.8c0-1.545-1.255-2.8-2.8-2.8h-78.7a2.802 2.802 0 0 0-2.8 2.8V431c0 1.545 1.255 2.8 2.8 2.8h78.7c1.545 0 2.8-1.255 2.8-2.8v-97.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.8 338c0-1.545-1.255-2.8-2.8-2.8h-70.4a2.802 2.802 0 0 0-2.8 2.8v47.9c0 1.545 1.255 2.8 2.8 2.8H425c1.545 0 2.8-1.255 2.8-2.8V338Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M351.8 392.8h19.8v8.3h-19.8zM351.8 402.5h76v7h-76zM351.8 422.7h19.4v6.9h-19.4zM420.8 422.7h6.9v6.9h-6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.4 333.8c0-1.545-1.255-2.8-2.8-2.8h-78.7a2.802 2.802 0 0 0-2.8 2.8V431c0 1.545 1.255 2.8 2.8 2.8h78.7c1.545 0 2.8-1.255 2.8-2.8v-97.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.2 338c0-1.545-1.255-2.8-2.8-2.8H443a2.802 2.802 0 0 0-2.8 2.8v47.9c0 1.545 1.255 2.8 2.8 2.8h70.4c1.545 0 2.8-1.255 2.8-2.8V338Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M440.2 392.8H460v8.3h-19.8zM440.2 402.5h76.1v7h-76.1zM440.2 422.7h19.5v6.9h-19.5zM509.2 422.7h7v6.9h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.8 333.8c0-1.545-1.255-2.8-2.8-2.8h-78.7a2.802 2.802 0 0 0-2.8 2.8V431c0 1.545 1.255 2.8 2.8 2.8H606c1.545 0 2.8-1.255 2.8-2.8v-97.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.7 338c0-1.545-1.255-2.8-2.8-2.8h-70.4a2.802 2.802 0 0 0-2.8 2.8v47.9c0 1.545 1.255 2.8 2.8 2.8h70.4c1.545 0 2.8-1.255 2.8-2.8V338Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M528.7 392.8h19.8v8.3h-19.8zM528.7 402.5h76v7h-76zM528.7 422.7h19.4v6.9h-19.4zM597.7 422.7h6.9v6.9h-6.9zM259.2 447.7h85.7v10.4h-85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 466.4c0-1.545-1.255-2.8-2.8-2.8H262a2.802 2.802 0 0 0-2.8 2.8v54.1c0 1.545 1.255 2.8 2.8 2.8h108.2c1.545 0 2.8-1.255 2.8-2.8v-54.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M263.3 467.8h19.8v8.3h-19.8zM263.3 477.5h53.4v7h-53.4zM263.3 512.2h19.5v7h-19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.7 470.6c0-1.545-1.255-2.8-2.8-2.8h-42.3a2.802 2.802 0 0 0-2.8 2.8v45.8c0 1.545 1.255 2.8 2.8 2.8h42.3c1.545 0 2.8-1.255 2.8-2.8v-45.8Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.9 466.4c0-1.545-1.255-2.8-2.8-2.8H379.9a2.802 2.802 0 0 0-2.8 2.8v54.1c0 1.545 1.255 2.8 2.8 2.8h108.2c1.545 0 2.8-1.255 2.8-2.8v-54.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M381.3 467.8h19.8v8.3h-19.8zM381.3 477.5h53.3v7h-53.3zM381.3 512.2h19.4v7h-19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.7 470.6c0-1.545-1.255-2.8-2.8-2.8h-42.3a2.802 2.802 0 0 0-2.8 2.8v45.8c0 1.545 1.255 2.8 2.8 2.8h42.3c1.545 0 2.8-1.255 2.8-2.8v-45.8Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.8 466.4c0-1.545-1.255-2.8-2.8-2.8H497.8a2.802 2.802 0 0 0-2.8 2.8v54.1c0 1.545 1.255 2.8 2.8 2.8H606c1.545 0 2.8-1.255 2.8-2.8v-54.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M499.2 467.8H519v8.3h-19.8zM499.2 477.5h53.4v7h-53.4zM499.2 512.2h19.4v7h-19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.6 470.6c0-1.545-1.255-2.8-2.8-2.8h-42.3a2.802 2.802 0 0 0-2.8 2.8v45.8c0 1.545 1.255 2.8 2.8 2.8h42.3c1.545 0 2.8-1.255 2.8-2.8v-45.8Z",
    style: {
      fill: "#cbd4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M259.2 537.2h85.7v10.5h-85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 554.5v30c0 .8-1.3 1.5-2.8 1.5H261.8c-1.5 0-2.8-.7-2.8-1.5v-30c0-.8 1.3-1.5 2.8-1.5h108.4c1.5 0 2.8.7 2.8 1.5Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M263.3 557.4h19.8v8.3h-19.8zM263.3 567.1h53.4v7h-53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 558.6v25.8c0 .9-1.3 1.6-2.8 1.6h-42.4c-1.5 0-2.8-.7-2.8-1.6v-25.8c0-.9 1.3-1.6 2.8-1.6h42.4c1.5 0 2.8.7 2.8 1.6Z",
    style: {
      fill: "#cbd4e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 554.5v30c0 .8-1.3 1.5-2.8 1.5H379.8c-1.5 0-2.8-.7-2.8-1.5v-30c0-.8 1.3-1.5 2.8-1.5h108.4c1.5 0 2.8.7 2.8 1.5Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M381.3 557.4h19.8v8.3h-19.8zM381.3 567.1h53.3v7h-53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 558.6v25.8c0 .9-1.3 1.6-2.8 1.6h-42.4c-1.5 0-2.8-.7-2.8-1.6v-25.8c0-.9 1.3-1.6 2.8-1.6h42.4c1.5 0 2.8.7 2.8 1.6Z",
    style: {
      fill: "#cbd4e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 554.5v30c0 .8-1.3 1.5-2.8 1.5H497.8c-1.5 0-2.8-.7-2.8-1.5v-30c0-.8 1.3-1.5 2.8-1.5h108.4c1.5 0 2.8.7 2.8 1.5Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e8f0",
      fillRule: "nonzero"
    },
    d: "M499.2 557.4H519v8.3h-19.8zM499.2 567.1h53.4v7h-53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 558.6v25.8c0 .9-1.3 1.6-2.8 1.6h-42.4c-1.5 0-2.8-.7-2.8-1.6v-25.8c0-.9 1.3-1.6 2.8-1.6h42.4c1.5 0 2.8.7 2.8 1.6Z",
    style: {
      fill: "#cbd4e1",
      fillRule: "nonzero"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "a",
    width: 6,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAATUlEQVQImXXMOxGAQBRD0bMfN0hAAhhaAygCFbRAj5CdoeBRkjL3Jmk/7oQBkzcbzhrlgh5gRKthdpQAHXP2kxyfJcxvuVacaJhDXnE9AUUQFsG7s8QAAAAASUVORK5CYII="
  }))));
};
export default SvgIllustration;